export default "__VITE_ASSET__BSJRvGgc__"